/**
 * Temporary table components used while Import Hub is being migrated to AG Grid.
 * TODO: Remove them after all tables in this microfrontend have moved to AG Grid.
 */
import { DEFAULT_HEADER_CELLS_COUNT } from '../../constants/tablesConfig.js';
import { TableHeadCellSkeleton } from '../atoms/TableHeadCellSkeleton.jsx';
import { TableBodyCell, TableHead, TableRow } from './TableComponents.jsx';

type TableHeadSkeletonProps = {
  cellsCount?: number;
};

export const TableHeadSkeleton = ({
  cellsCount = DEFAULT_HEADER_CELLS_COUNT,
}: TableHeadSkeletonProps) => {
  const cells = Array.from(
    { length: cellsCount },
    (_, index) => `skeleton-header-cell-${index}`,
  );

  return (
    <TableHead>
      <TableRow>
        {cells.map((cell) => (
          <TableHeadCellSkeleton key={cell} />
        ))}
      </TableRow>
    </TableHead>
  );
};

type TableSkeletonRowsProps = {
  cellsCount?: number;
  rowsCount: number;
};

export const TableSkeletonRows = ({
  cellsCount = DEFAULT_HEADER_CELLS_COUNT,
  rowsCount,
}: TableSkeletonRowsProps) =>
  Array.from(
    { length: rowsCount },
    (_, rowIndex) => `skeleton-row-${rowIndex}`,
  ).map((rowKey) => (
    <TableRow key={rowKey}>
      {Array.from(
        { length: cellsCount },
        (_, cellIndex) => `skeleton-cell-${cellIndex}`,
      ).map((cellKey) => (
        <TableBodyCell key={`${rowKey}-${cellKey}`} isLoading />
      ))}
    </TableRow>
  ));
